import { env, toResponseError, getAuthToken, handleUnauthorized } from '@eruvaka/web-pondlogs-base';
// Shared fetch helper: tries raw token, retries with Bearer on 401
const authFetch = async (url, options) => {
    const token = getAuthToken();
    const method = options?.method ?? 'GET';
    let response = await fetch(url, {
        ...options,
        method,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: token } : {}),
            ...(options?.headers ?? {}),
        },
    });
    if (response.status === 401 && token) {
        response = await fetch(url, {
            ...options,
            method,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
                ...(options?.headers ?? {}),
            },
        });
    }
    // After retry, if still 401, fire the unauthorized event
    if (response.status === 401) {
        handleUnauthorized();
    }
    return response;
};
export const fetchReleaseNotes = async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.platform)
        queryParams.append('platform', params.platform);
    if (params.search)
        queryParams.append('search', params.search);
    const url = `${env.apiBaseUrl}/api/v3/help/release-notes${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const response = await authFetch(url);
    if (!response.ok) {
        const body = await response.text();
        throw toResponseError(response.status, body);
    }
    return response.json();
};
export const fetchProductManuals = async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.manual_type)
        queryParams.append('manual_type', params.manual_type);
    if (params.language)
        queryParams.append('language', params.language.toUpperCase());
    if (params.status)
        queryParams.append('status', params.status);
    if (params.limit != null)
        queryParams.append('limit', String(params.limit));
    if (params.sort)
        queryParams.append('sort', params.sort);
    const url = `${env.apiBaseUrl}/api/v3/help/product-manuals?${queryParams.toString()}`;
    const response = await authFetch(url);
    if (!response.ok) {
        const body = await response.text();
        throw toResponseError(response.status, body);
    }
    return response.json();
};
// ── Mark Release Note as Watched ───────────────────────────────────────────
export const markReleaseNoteWatched = async (releaseNoteId) => {
    const url = `${env.apiBaseUrl}/api/v3/help/release-notes/${releaseNoteId}/mark-watched`;
    const response = await authFetch(url, { method: 'POST' });
    if (!response.ok) {
        // Fire-and-forget — swallow errors silently; viewed state is optimistic
        return;
    }
};
export const getReleaseAssetProxyUrl = (assetUrl) => {
    // Proxy only S3 URLs; preserve non-S3 URLs as-is.
    const isS3Url = assetUrl.includes('.s3.') ||
        assetUrl.includes('.amazonaws.com/') ||
        assetUrl.includes('s3.amazonaws.com/');
    if (!isS3Url) {
        return assetUrl;
    }
    const query = new URLSearchParams({ url: assetUrl }).toString();
    return `${env.apiBaseUrl}/api/v3/help/release-notes/file/fetch?${query}`;
};
